import DatePicker, { forwardRef } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faCalendar } from "@fortawesome/free-solid-svg-icons";

const CustomInput = ({ value, onClick, placeholder }) => (
  <div className="input-group">
    <input
      type="text"
      className="form-control"
      value={value}
      onClick={onClick}
      // ref={ref}
      placeholder={placeholder}
      readOnly // Prevent typing in the input
    />
    {/* <span className="input-group-text">
      <FontAwesomeIcon icon={faCalendar} />
    </span> */}
  </div>
);

const CustomDatePicker = ({ field, form, min, max, placeholder }) => {
  const { setFieldValue, validateField } = form;
  const { name, value } = field;
  const minDate = moment("01-01-1900", "DD-MM-YYYY").toDate();
  return (
    <DatePicker
      selected={value ? moment(value, "DD-MM-YYYY").toDate() : null}
      onChange={(date) => {
        setFieldValue(name, moment(date).format("DD-MM-YYYY"));
        validateField && validateField(name);
      }}
      onBlur={() => {
        validateField && validateField(name);
      }}
      popperPlacement="bottom-start" /* Ensures it positions correctly */
      portalId="root"
      dateFormat="dd-MM-yyyy"
      className="form-control w-100"
      placeholderText={placeholder || "Select date"}
      showYearDropdown
      showMonthDropdown
      scrollableYearDropdown
      yearDropdownItemNumber={100}
      minDate={min || minDate}
      maxDate={max || new Date()}
      customInput={<CustomInput placeholder={placeholder || "Select date"} />}
    />
  );
};

export default CustomDatePicker;
